import Layout from "../../components/layout";
import {GetStaticProps} from "next";
import Link from "../../components/Link";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import '../../styles/scss/_events-page.module.scss';

export default function KubeConKickoffIndia({ props }) {
    const { t } = useTranslation('common');
    const pageData = t('resources.events.pages.kubeconKickoffIndia2025', { returnObjects: true, defaultValue: {} }) as any;
    
    const heroData = pageData?.hero || {};
    const contentData = pageData?.content || {};
    const agendaData = contentData?.agenda || {};
    const expectationsData = contentData?.expectations || {};
    const swagData = contentData?.swag || {};
    const missedUsData = contentData?.missedUs || {};
    
    // Helper function to safely convert to string (handles objects)
    const safeString = (value: any): string => {
        if (value === null || value === undefined) return '';
        if (typeof value === 'string') return value;
        if (typeof value === 'object') {
            if (value.text) return String(value.text);
            if (value.value) return String(value.value);
            if (value.label) return String(value.label);
            return '';
        }
        return String(value);
    };
    
    return(
        <>
            <Layout isHomePage={false} pageTitle={String(pageData?.pageTitle ?? '')}
                    ogImage={String(pageData?.ogImage ?? '')}
                    uri={String(pageData?.uri ?? '')}
                    metaTitle={String(pageData?.metaTitle ?? '')}
                    metaDesc={String(pageData?.metaDesc ?? '')}
                    metaRobotsNoindex={String(pageData?.metaRobotsNoindex ?? '')}
                    metaRobotsNofollow={String(pageData?.metaRobotsNofollow ?? '')}>

                <div className={'global-wrapper'} >
                    <div className={"event-page dine-with-devops"}>
                        <section className={'hero-section'}>
                            <div className={'container'}>
                                <div className={'d-flex'}>
                                    <div className={'left-block'}>
                                        <Link href={String(heroData?.backLinkUrl ?? '/events/')} className={"back-to-blog"}>{String(heroData?.backLink ?? '')}</Link>
                                        {heroData?.logo && (
                                            <div className={'d-flex aws-mw'}>
                                                <img src={safeString(heroData.logo?.src)} alt={safeString(heroData.logo?.alt)} className={'aws-logo'} width={"100%"} height={"100%"}/>
                                            </div>
                                        )}
                                        <div className={'inner-hero'}>
                                            <h1>
                                                {safeString(heroData?.titlePrefix ?? '')}
                                                <span>{safeString(heroData?.titleHighlight ?? '')}</span>
                                                {safeString(heroData?.titleMiddle ?? '')}
                                                <span>{safeString(heroData?.titleHighlight2 ?? '')}</span>
                                                {safeString(heroData?.titleSuffix ?? '')}
                                            </h1>
                                            {heroData?.date && <p><b>Date: </b>{safeString(heroData.date)}</p>}
                                            {heroData?.time && <p><b>Time: </b>{safeString(heroData.time)}</p>}
                                            {heroData?.venue && <p><b>Venue: </b>{safeString(heroData.venue)}</p>}
                                        </div>
                                    </div>
                                    <div className={'right-block closed'}>
                                        <img
                                            src={String(heroData?.image?.src ?? '')} alt={String(heroData?.image?.alt ?? '')} width={"100%"} height={"100%"}/>
                                    </div>
                                </div>

                            </div>
                        </section>
                        <section className={'content-section'}>
                            <div className={'container'}>
                                <div className={'left-block sm-width'}>
                                    <p dangerouslySetInnerHTML={{__html: String(contentData?.description ?? '')}}></p>
                                    
                                    {Array.isArray(contentData?.specialContent) && contentData.specialContent.map((content: string, index: number) => (
                                        <p key={index} dangerouslySetInnerHTML={{__html: String(content).replace(/<Link/g, '<a').replace(/<\/Link>/g, '</a>')}}></p>
                                    ))}

                                    {agendaData?.title && (
                                        <>
                                            <h4>{String(agendaData.title)}</h4>
                                            {Array.isArray(agendaData?.items) && (
                                                <ul>
                                                    {agendaData.items.map((item: string, index: number) => (
                                                        <li key={index} dangerouslySetInnerHTML={{__html: String(item).replace(/<Link/g, '<a').replace(/<\/Link>/g, '</a>')}}></li>
                                                    ))}
                                                </ul>
                                            )}
                                        </>
                                    )}

                                    {expectationsData?.title && (
                                        <>
                                            <p>{String(expectationsData.title)}</p>
                                            {Array.isArray(expectationsData?.items) && (
                                                <ul>
                                                    {expectationsData.items.map((item: string, index: number) => (
                                                        <li key={index} dangerouslySetInnerHTML={{__html: String(item).replace(/<Link/g, '<a').replace(/<\/Link>/g, '</a>')}}></li>
                                                    ))}
                                                </ul>
                                            )}
                                        </>
                                    )}

                                    {contentData?.eventLink && (
                                        <p dangerouslySetInnerHTML={{__html: String(contentData.eventLink).replace(/<Link/g, '<a').replace(/<\/Link>/g, '</a>')}}></p>
                                    )}

                                    {swagData?.title && (
                                        <>
                                            <h4>{String(swagData.title)}</h4>
                                            {swagData?.image && (
                                                <img src={String(swagData.image.src)} alt={String(swagData.image.alt)} width={100} height={100}/>
                                            )}
                                            <p>{String(swagData?.description ?? '')}</p>
                                        </>
                                    )}

                                    {missedUsData?.title && (
                                        <>
                                            <h4>{String(missedUsData.title)}</h4>
                                            <p dangerouslySetInnerHTML={{__html: String(missedUsData?.description ?? '').replace(/<Link/g, '<a').replace(/<\/Link>/g, '</a>')}}></p>
                                        </>
                                    )}

                                </div>


                            </div>
                        </section>
                    </div>
                </div>

            </Layout>
        </>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const translations = await serverSideTranslations(
    ctx?.locale ?? "en",
    ["common", "header", "footer"],
    nextI18NextConfig,
  );
    return {
        props: {
            ...translations,
            pageTitle: "Tech Leaders' Roundtable at KubeCon Kickoff Hyderabad",
            description: "Join Middleware’s Tech Leaders' Roundtable on Aug 5 in Hyderabad to explore observability challenges and real-world Kubernetes solutions. Don’t miss out!",
            ogImage: "/images/events/kubecon-kickoff-india-2025.webp",
            uri: "/events/kubecon-kickoff-india-2025/",
            metaTitle: "Tech Leaders' Roundtable at KubeCon Kickoff Hyderabad",
            metaDesc: "Join Middleware’s Tech Leaders' Roundtable on Aug 5 in Hyderabad to explore observability challenges and real-world Kubernetes solutions. Don’t miss out!",
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
        },
    }
}
